/**
 * It's a generated file, preferable to extend this in external file
 */
import {TransportTypeName} from 'common/enums';
import * as yup from 'common/yup';
import {TransportType} from 'types/TransportType';
import {AbstractTransport, transportTypeSchema} from '../Abstract/AbstractTransport';
import {transportTypeNameSchema} from '../TransportTypeName';
import {ZohoWorkdriveServer} from './ZohoWorkdriveServer';

export const ZohoWorkdriveTransport = AbstractTransport.shape({
   typeName: transportTypeNameSchema.default(TransportTypeName.WORKDRIVE),
   transportType: transportTypeSchema.default(TransportType.enum.WORKDRIVE),
   server: ZohoWorkdriveServer,
});
export type IZohoWorkdriveTransport = yup.InferType<typeof ZohoWorkdriveTransport>;
